import styled from 'styled-components'

export const SlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 449.33px;
  width: 100%;
  padding: 50px;
  border-radius: 20px;
  height: 100%;
  background: ${({ theme }) => theme.fixedPanelBg};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 30px 0;
    max-width: 100%;
`}
`
export const SlideImageContainer = styled.div`
  position: relative;
  align-self: center;
  max-width: 270px;
  width: 100%;
  height: 555px;
  margin-bottom: 28px;
  overflow: hidden;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 187px;
    height: 388px;
    margin-bottom: 15px;
  `}
`

export const SlideImageFrame = styled.img`
  max-width: 270px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 3;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 187px;
  `}
`

export const SlideImageIphone = styled.img`
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 2;
  border-radius: 30px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 187px;
  `}
`

export const SlideImageAndroid = styled.img`
  position: absolute;
  top: 2.5px;
  left: 2.5px;
  width: calc(100% - 5px);
  height: calc(100% - 5px);
  z-index: 2;
  border-radius: 15px;
  max-width: 187px;
`

export const SlideTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 313px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    gap: 5px;
    align-self: center;
    align-items: center;
  `}
`

export const SlideType = styled.p`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 14px;
    line-height: 18px;
  `}
`

export const SlideTitle = styled.h3`
  font-size: 26px;
  font-weight: 500;
  line-height: 34px;
  margin: 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 18px;
    line-height: 23px;
  `}
`
export const SlideDescription = styled.p`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.accentText};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  `}
`
